import LazyLoad from 'lazyload';
import Geolocalisation from './geolocalisation';
import Sound from './../components/sound';

export default class Nav {
    constructor() {
        this.open();
        this.close();
        this.closeBtn();
        this.lazy();
        this.closeNews();
        this.checkLanguage();
        this.introductionPopin();
        this.toggleOrderPopin();

        new Geolocalisation();
    }

    open() {
        const burger = document.querySelector('header .burger');
    	if(burger){
            burger.addEventListener('click', () => {
                document.querySelector('nav').classList.toggle('open');
                document.querySelector('.nav-overlay').style.display = 'block';
                document.querySelector('.close-nav').style.display = 'block';

                if(window.innerWidth < 768){
                    burger.style.opacity = '0';
                }
            });
        }
    }

    close() {
        const overlay = document.querySelector('.nav-overlay');
    	if(overlay){
            overlay.addEventListener('click', () => {
                document.querySelector('nav').classList.remove('open');
                document.querySelector('.nav-overlay').style.display = 'none';
                document.querySelector('.close-nav').style.display = 'none';

                if(window.innerWidth < 768){
                    document.querySelector('header .burger').style.opacity = '1';
                }
            });
        }
    }

    closeBtn() {
        const btn = document.querySelector('.close-nav');
        if(btn){
            btn.addEventListener('click', () => {
                document.querySelector('nav').classList.remove('open');
                document.querySelector('.nav-overlay').style.display = 'none';
                document.querySelector('.close-nav').style.display = 'none';

                if(window.innerWidth < 768){
                    document.querySelector('header .burger').style.opacity = '1';
                }
            });
        }
    }

    lazy() {
        let images = document.querySelectorAll('.b-lazy');
        new LazyLoad(images, {
            root: null,
            rootMargin: '50px',
            threshold: 0
        });
    }

    closeNews() {
        const news_message = document.querySelector('aside.message-newsletter');
        if(news_message){
            news_message.querySelector('.close').addEventListener('click', function() {
                this.parentElement.classList.remove('open');
            });
        }
    }

    introductionPopin() {
        const introPopin = document.querySelector('.message-popin');
        if (introPopin) {
            if (sessionStorage.getItem('popinOpenned') != 'true') {
                sessionStorage.setItem('popinOpenned', 'true');
                introPopin.classList.add('open');
            }

            introPopin.querySelector('.close').addEventListener('click', function(){
                this.parentElement.classList.remove('open');
            });
        }
    }

    checkLanguage() {
        const links = document.querySelectorAll('aside.language-popin .text-container a');
        if (links.length > 0) {
            Array.from(links).forEach( link => {
                link.addEventListener('click', function(e){
                    if (link.href = window.location.href) {
                        e.preventDefault();
                        document.querySelector('aside.language-popin').style.display = 'none';
                        // new Sound().getPlaylist();
                    }
                });
            });
        }
    }

    toggleOrderPopin() {
      const cta = document.querySelector('header .cta');
      if (cta) {
        cta.addEventListener('click', () => {
          document.querySelector('aside.message-btns').classList.add('open');
          document.querySelector('.overlay-btns').style.display = 'block';
        });

        if (document.querySelector('aside.message-btns .close')) {
          document.querySelector('aside.message-btns .close').addEventListener('click', () => {
            document.querySelector('aside.message-btns').classList.remove('open');
            document.querySelector('.overlay-btns').style.display = '';
          });
        }

        if (document.querySelector('.overlay-btns')) {
          document.querySelector('.overlay-btns').addEventListener('click', () => {
            document.querySelector('aside.message-btns').classList.remove('open');
            document.querySelector('.overlay-btns').style.display = '';
          });
        }
      }
    }
}